import { useRef } from "react";
import Button, { ButtonA } from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import useContactCircleModalPosition from "components/Pages/Home/hooks/useContactCircleModalPosition";
import useHasAvailableProjects from "./hooks/useHasAvailableProjects";
import PickerPromoFreeModal from "./Modals/PickerPromoFreeModal";
import Login from "components/Structure/Login/Login";
import PickerPromoLimitProjectsModal from "./Modals/PickerPromoLimitProjectsModal";
import { setLocalStorage } from "utils/globalLocalStorage";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";

import styles from "./pickerPromo.module.scss";

interface IPickerPromoModal {
  targetRef: HTMLDivElement;
}

const PickerPromoTooltip = ({ targetRef }: IPickerPromoModal) => {
  const modalWindowRef = useRef(null);

  const { closeModal, setModal } = useModal();
  const { getTextByKey, getDirection } = useContent();

  const { cords, arrowStyle } = useContactCircleModalPosition({
    targetRef,
    modalWindowRef,
  });

  const { anonimus, notSubscriber, premium, available, fetched } =
    useHasAvailableProjects();

  const handleClick = () => {
    if (anonimus) {
      setLocalStorage("pickerPromoShow", true); // when user did login we show promo again
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
      return;
    }

    if (notSubscriber) {
      setModal({
        modal: PickerPromoFreeModal,
      });
      return;
    }

    if (!available) {
      setModal({
        modal: PickerPromoLimitProjectsModal,
        modalSize: "full-modal",
      });
      return;
    }
  };

  return (
    <div
      className={`tooltip-modal ${styles.promoTooltip} ${
        getDirection() === "rtl" ? styles.rtl : ""
      }`}
      style={cords}
      ref={modalWindowRef}
    >
      <Button
        onClick={closeModal}
        className={"close-button " + styles.closeButton}
      >
        <Icon name="x" white />
      </Button>
      <div className="tooltip-modal-header">
        <Image name="home/picker-promo-grid" ext="png" />
      </div>
      <div className="tooltip-modal-content">
        <h3 className={styles.title}>
          {getTextByKey("picker-promo-homepage-modal-title")}
        </h3>
        <p className={styles.text}>
          {getTextByKey("picker-promo-homepage-modal-text")}
        </p>
      </div>
      <div className={styles.buttons}>
        <ButtonA page="jumbo-picker" buttonClass={styles.blank}>
          {getTextByKey("learn-more")}
        </ButtonA>
        {premium || available ? (
          <ButtonA page="inbox?t=picker&create=true" disabled={!fetched}>
            {getTextByKey("create")}
          </ButtonA>
        ) : (
          <Button
            onClick={handleClick}
            buttonClass={styles.send}
            disabled={!fetched}
          >
            {getTextByKey("create")}
          </Button>
        )}
      </div>
      <div className="tooltip-arrow" style={arrowStyle} />
    </div>
  );
};

export default PickerPromoTooltip;
